import styled, { keyframes, css } from 'styled-components'

import { Color } from 'constants/color'

export const Wrapper = styled.div`
    position: absolute;
    z-index: 17;
    ${props =>
        props.teacher
            ? css`
                  width: 30%;
                  top: -4%;
                  left: -8%;
              `
            : css`
                  width: 60%;
                  top: -3%;
                  left: -10%;
              `};
    transform: scale(
            ${props => (props.vibingIntensity ? props.vibingIntensity : 1)}
        )
        rotate(-34deg);
    transition: transform 0.5s ease;
`

const flicker = keyframes`
    7%, 100%{
        opacity: 0;
    }

    9%, 81%{
        opacity: 1;
    }
`

export const Svg = styled.svg`
    width: 100%;
    height: 100%;
    opacity: 1;
    animation: ${flicker} ease 2.2s;
    transition: opacity 2.2s linear;
`
